const basicRegister = {
  name: '',
  nationalIdentification: '',
  phone: '',
  email: '',
  message: ''
};

export default basicRegister;
